import React from 'react';
import { useHistory } from 'react-router-dom';
import {
  Accordion,
  AccordionButton,
  AccordionIcon,
  AccordionItem,
  AccordionPanel,
  Box, Button, Divider, Flex, Text
} from '@chakra-ui/react';
import PropTypes from 'prop-types';

import LogoBox from '../../components/Header/LogoBox';
import loginBackground from '../../loginBackground.png';
import boxStyles from '../../styles/boxStyles';
import colors from '../../styles/theme/foundation/colors';

const MissingUserPage = ({ props }) => {
  const history = useHistory();

  return (
    <Box
      backgroundImage={loginBackground}
      backgroundPosition="center"
      backgroundSize="cover"
      h="100vh"
      position="relative"
      w="100vw"
    >
      <Box
        h="40px"
        left={6}
        position="absolute"
        top={6}
      >
        <LogoBox to="/" />
      </Box>

      <Box
        alignItems="center"
        display="flex"
        h="100%"
        justifyContent="center"
        p={6}
      >
        <Box
          bgColor={colors.white}
          borderRadius="sm"
          boxShadow={boxStyles.boxShadow}
          mx="auto"
          my="auto"
          p={8}
          w="650px"
        >
          <Text
            mb={4}
            textAlign="center"
            textStyle="bodyXxl500"
          >
            Hmmm, PINS does not recognize this email address.
          </Text>

          <Button
            mb={4}
            variant="primary"
            w="60%"
            onClick={() => history.push('login')}
          >
            Back to Login Page
          </Button>

          <Flex align="center" my={6}>
            <Divider borderColor="gray.600" />
            <Text color="gray.600" fontSize="sm" mx={3}>
              FAQ
            </Text>
            <Divider borderColor="gray.600" />
          </Flex>

          <Accordion allowToggle>
            <AccordionItem border="none">
              <h2>
                <AccordionButton px={0}>
                  <Box flex="1" fontWeight="semibold" textAlign="left">
                    I work for a company with a PINS account.  Why is my email not recognized?
                  </Box>
                  <AccordionIcon />
                </AccordionButton>
              </h2>
              <AccordionPanel pb={4} px={0}>
                <Text mb={3} textAlign="left" textStyle="bodyXl">
                  If you used one of our Single Sign On (SSO) methods (e.g. Google, Outlook, etc.), please confirm that
                  you are using the same email address that you used to sign up for PINS.
                  If you&#39;d like to use the email address for SSO, please contact your company admin and request to
                  have this email address added as a user to your PINS account.
                </Text>
              </AccordionPanel>
            </AccordionItem>

            <AccordionItem border="none">
              <h2>
                <AccordionButton px={0}>
                  <Box flex="1" fontWeight="semibold" textAlign="left">
                    I am an agent trying to upload a certificate into PINS.  How can I get into PINS to do this?
                  </Box>
                  <AccordionIcon />
                </AccordionButton>
              </h2>
              <AccordionPanel pb={4} px={0}>
                <Text textAlign="left" textStyle="bodyXl">
                  You should have received an email with a unique link to process your submission.
                  If you cannot find this email, please reach out to the certificate holder
                  to request a new email link.
                </Text>
              </AccordionPanel>
            </AccordionItem>
          </Accordion>
        </Box>
      </Box>
    </Box>
  );
};

MissingUserPage.propTypes = {};

export default MissingUserPage;
